import { Summary } from "routes/schedule/components/summary"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { formatTime } from "lib/format-time"
import { Box } from "@mui/material"

export function ClassificationSummary({ item, results, totalMinutes }) {
    return (
        <Box width={"15vw"} pb={2} minWidth={160} overflow="hidden">
            <Summary
                title={item}
                percent={(100 * (results[item]?.minutes ?? 0)) / totalMinutes}
                color={COLOR_FROM_CLASSIFICATION[item]}
                icon={ICON_FROM_CLASSIFICATION[item]}
                total={results[item]?.count ?? 0}
                time={formatTime(results[item]?.minutes ?? 0)}
            />
        </Box>
    )
}
